import React from 'react';
import './Header.css';
import ROUTES from '../common/Routing/Routes';
import { NavLink, useNavigate } from 'react-router-dom';
import MainSearch from './MainSearch/MainSearch';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import LoginIcon from '@mui/icons-material/Login';
import { Box, Popover, Badge, Tooltip } from '@mui/material';
import LoginPage from '../Pages/LoginPage/LoginPage';
import { useAuth } from '../common/Auth/AuthProvider';
import { useCart } from '../../contexts/CartContext';

function Header() {
  const { isAuthenticated, isAuthInitialized, user } = useAuth();
  const isAdmin = isAuthInitialized && user?.role === 'Admin';
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const handleClose = () => setAnchorEl(null);

  const handleProfileClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!isAuthInitialized) {
      return;
    }

    if (isAuthenticated) {
      navigate(ROUTES.PROFILE);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const { cartCount, openCartModal } = useCart();

  React.useEffect(() => {
    if (isAuthenticated) {
      setAnchorEl(null);
    }
  }, [isAuthenticated]);

  return (
    <header className="header">
      <nav className="header-container default-container">
        <NavLink to={ROUTES.HOME} aria-label="Readerly" className="header-logo-link">
          <span className="readerly-mark" aria-hidden="true">R</span>
          <span className="readerly-word">Readerly</span>
        </NavLink>

        <div className="header-links">
          <NavLink to={ROUTES.HOME}>Книги</NavLink>
          <NavLink to={ROUTES.TOP}>Топи</NavLink>
          <NavLink to={ROUTES.SHOP}>Крамничка</NavLink>
          <NavLink to={ROUTES.FAQ}>Як це працює</NavLink>
          <NavLink to={ROUTES.ABOUT}>Про нас</NavLink>
          {isAuthenticated && <NavLink to={ROUTES.WISH_LIST}>Вішліст</NavLink>}
          {isAdmin && <NavLink to={ROUTES.ADMIN}>Адмінка</NavLink>}
        </div>

        <MainSearch />

        <div className="header-actions">
          {isAuthInitialized && (
            <Tooltip title={isAuthenticated ? 'Профіль' : 'Увійти'}>
              <div className="d-flex header-icon cursor-pointer header-icon-button" onClick={handleProfileClick}>
                {isAuthenticated ? <AccountCircleIcon fontSize="large" /> : <LoginIcon fontSize="large" />}
              </div>
            </Tooltip>
          )}

          {isAuthenticated && (
            <Tooltip title="Вішліст">
              <div className="d-flex header-icon cursor-pointer header-icon-button" onClick={() => navigate(ROUTES.WISH_LIST)}>
                <FavoriteBorderIcon fontSize="large" />
              </div>
            </Tooltip>
          )}

          <div className="d-flex header-icon cursor-pointer header-icon-button" onClick={openCartModal}>
            <Badge badgeContent={cartCount} color="primary">
              <ShoppingCartIcon fontSize="large" />
            </Badge>
          </div>
        </div>
      </nav>

      <Popover
        keepMounted
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Box className="header-login-popover">
          <LoginPage onLoginSuccess={handleClose} onClose={handleClose} />
        </Box>
      </Popover>
    </header>
  );
}

export default Header;
